import { ChevronRightIcon } from 'lucide-react'

/** The chevron of every "Request a demo", nudging toward where the button leads on hover. */
export function DemoChevron() {
  return (
    <ChevronRightIcon
      data-icon="inline-end"
      className="transition-transform duration-200 ease-out group-hover/button:translate-x-0.5 motion-reduce:transition-none"
    />
  )
}

/** The same nudge for a text link: put `group/cta-link` on the link. */
export function LinkChevron() {
  return (
    <ChevronRightIcon
      aria-hidden
      className="size-4 shrink-0 transition-transform duration-200 ease-out group-hover/cta-link:translate-x-1 group-focus-visible/cta-link:translate-x-1 motion-reduce:transition-none"
    />
  )
}
